export default function getScriptParamsByURL(prefix, target = document) {
    let scripts = target.querySelectorAll(`script[src*="${prefix}"]`);
    if (scripts?.length === 0) {
        return null;
    }
    for (const index in scripts) {
        const splittedUrl = scripts[index].src.split("?");
        const search = splittedUrl && splittedUrl.length > 1 ? splittedUrl[1] : null;
        if (search) {
            return JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
                return key === "" ? value : decodeURIComponent(value);
            });
        }
    }
    return null;
}
//# sourceMappingURL=getScriptParamsByURL.js.map